import userReducer from "./reducer";

export default userReducer;
